import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Container, Nav } from 'react-bootstrap';
import './index.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation(); // Using useLocation to track current path

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="custom-navbar">
      <Container className="navbar-container">
        {/* Logo */}
        <div className="navbar-logo">
          <Link to="/">
            <img src="/logo.jpeg" alt="Logo" className="logo-img" />
          </Link>
        </div>

        {/* Desktop Menu */}
        <Nav className="desktop-menu d-none d-lg-flex">
          <Link
            to="/"
            className={location.pathname === "/" ? "nav-link active" : "nav-link"}
          >
            Luxe Unbounded
          </Link>
          <Link
            to="/about"
            className={location.pathname === "/about" ? "nav-link active" : "nav-link"}
          >
            Portfolio
          </Link>
          <Link
            to="/services"
            className={location.pathname === "/services" ? "nav-link active" : "nav-link"}
          >
            Service
          </Link>
          <Link
            to="/collections"
            className={location.pathname === "/collections" ? "nav-link active" : "nav-link"}
          >
            Our Collections
          </Link>
          <Link
            to="/plans"
            className={location.pathname === "/plans" ? "nav-link active" : "nav-link"}
          >
            Membership Plans
          </Link>
          <Link to='/register'>
            <button className="register-btn">Register Now</button>
          </Link>
        </Nav>

        {/* Mobile Menu Button */}
        <div className="mobile-menu-toggle d-lg-none" onClick={toggleMenu}>
          <div className="hamburger">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        {/* Mobile Menu Overlay */}
        <div className={`mobile-menu-overlay ${isOpen ? "show" : ""}`}>
          <div className="mobile-menu-content">
            {/* Close Button in Overlay */}
            <div className="mobile-close-btn" onClick={toggleMenu}>
              <div className="hamburger open">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>

            <Nav className="mobile-nav-links">
              <Link
                to="/"
                className={location.pathname === "/" ? "nav-link active" : "nav-link"}
                onClick={toggleMenu}
              >
                Luxe Unbounded
              </Link>
              <Link
                to="/about"
                className={location.pathname === "/about" ? "nav-link active" : "nav-link"}
                onClick={toggleMenu}
              >
                Portfolio
              </Link>
              <Link
                to="/services"
                className={location.pathname === "/services" ? "nav-link active" : "nav-link"}
                onClick={toggleMenu}
              >
                Service
              </Link>
              <Link
                to="/collections"
                className={location.pathname === "/collections" ? "nav-link active" : "nav-link"}
                onClick={toggleMenu}
              >
                Our Collections
              </Link>
              <Link
                to="/plans"
                className={location.pathname === "/plans" ? "nav-link active" : "nav-link"}
                onClick={toggleMenu}
              >
                Membership Plans
              </Link>
            </Nav>
            <Link to='/register'>
              <button className="register-btn mobile-register-btn" onClick={toggleMenu}>
                Register Now
              </button>
            </Link>
          </div>
        </div>
      </Container>
    </nav>
  );
};

export default Navbar;